"use strict";
/**
 * Application configuration for code generation
 * This configuration is used by the app generator to create the app infrastructure files
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.appConfig = void 0;
/**
 * Default configuration for the Zlinkx application
 */
exports.appConfig = {
    appName: 'zlinkx',
    packageScope: '@zlinkx',
    sharedPackage: 'shared-v2',
    version: '1.0.0',
    serverPort: 8892,
    databaseName: 'zlinkx',
    features: {
        enhancedCORS: true,
        localhostSupport: true,
        staticFileHandling: true,
        dbHealthCheck: true,
        timestampUtils: true, // Now using timestamp utilities from shared
        requestContext: true,
        includePathIn404: true,
    },
    server: {
        jsonLimit: '10mb',
        formLimit: '10mb',
        // CORS origins will be configured at runtime in the server
        // This avoids accessing process.env in shared code
        corsOrigins: undefined,
    },
};
